import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=2f65f6a3&scoped=true"
import script from "./ScheduleItem.vue?vue&type=script&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&lang=js"
import style0 from "./ScheduleItem.vue?vue&type=style&index=0&id=2f65f6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65f6a3",
  null
  
)

export default component.exports